import { createTheme } from '@mui/material/styles';


export const commonFont = {
    regular: '"Roboto-Regular"',
    medium: '"Roboto-Medium"',
    black: '"Roboto-Black"',
    bold: '"Roboto-Bold"',
    italic: '"Roboto-Italic"',
    light: '"Roboto-Light"',
    boldCondensed: '"Roboto-BoldCondensed"',

}

export const theme = (config) => {
    // console.log("AAAA config:",config)
    let colours = config && config.appearance && config.appearance.colours ? config.appearance.colours : undefined;
    let isDarkMode = config && config.appearance.dark_mode;
    let colorScreenButton = getColor(colours, "SCREEN_BUTTON");
    let colorScreenCard = getColor(colours, "SCREEN_CARD");
    let colorScreenWallet = getColor(colours, "SCREEN_WALLET");

    let landingPageBg = getColor(colours, "LANDING_BACKGROUND");
    let landingPageButton = getColor(colours, "LANDING_CARD") ? getColor(colours, "LANDING_CARD") : colorScreenButton;
    let landingPageCard = getColor(colours, "LANDING_CARD");
    let landingPageText = getColor(colours, "LANDING_TEXT");
    colorScreenButton = colorScreenButton ? colorScreenButton : '#42a5f5';
    colorScreenCard = colorScreenCard ? colorScreenCard : '#cccccc';
    landingPageBg = landingPageBg ? landingPageBg : '#388e3c';
    landingPageButton = landingPageButton ? landingPageButton : '#388e3c';
    landingPageText = landingPageText ? landingPageText : '#212121';
    const rawTheme = createTheme()

    const theme = createTheme({
        components: {
            MuiAppBar: {
                styleOverrides: {
                    root: {
                        boxShadow: 'none',
                        backgroundColor: 'transparent'
                    },
                },
            },
            MuiIconButton: {
                styleOverrides: {
                    root: {
                        boxShadow: 'none',
                        backgroundColor: isDarkMode ? 'unset' : '#F5F5F7',
                    },
                },
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        textTransform: "capitalize",
                        padding: "10px 22px",
                    },
                    text: {
                        ":hover": {
                            backgroundColor: 'transparent',
                            color: '#6E6E73'
                        },
                        padding: "10px 0px"
                    },
                    // contained: {
                    //     borderRadius: 32
                    // },
                    outlined: {
                        color: isDarkMode ? '#ffffff' : undefined,
                        borderColor: colorScreenButton,
                        ':hover': {
                            backgroundColor: colorScreenButton,
                            color: '#ffffff'
                        }
                    },
                },
            },
            MuiBottomNavigationAction: {
                styleOverrides: {
                    label: {
                        color: '#6E6E73'
                    }
                }
            },
            MuiTextField: {
                styleOverrides: {
                    root: {
                        width: '100%',
                        fontFamily: commonFont.regular,
                        fontSize: '0.875rem',
                        // '& .MuiOutlinedInput-root': {
                        //     borderRadius: 32,
                        // },
                        // '& .MuiFilledInput-root': {
                        //     borderRadius: 32,
                        // },
                        '& .MuiOutlinedInput-input': {
                            paddingTop: 12,
                            paddingBottom: 12,
                            fontFamily: commonFont.medium,
                            fontSize: '0.875rem',
                        }
                    },
                },
            },
            MuiSelect: {
                styleOverrides: {
                    root: {
                        width: '100%',
                        // borderRadius: 32,
                        '& .MuiOutlinedInput-input': {
                            paddingTop: 12,
                            paddingBottom: 12,
                        }
                    }
                }
            },
            MuiDrawer: {
                styleOverrides: {
                    root: {
                        '& .MuiDrawer-paper': {
                            width: '40%',
                            padding: 24,
                            [rawTheme.breakpoints.down('md')]: {
                                width: '60%',
                            },
                            [rawTheme.breakpoints.down('sm')]: {
                                width: '80%',
                                padding: 12,
                            },
                        }
                    }
                }
            },
            MuiCard: {
                styleOverrides: {
                    root: {
                        padding: 0,
                        borderWidth: 1,
                        borderColor: isDarkMode ? 'rgba(255,255,255,0.12)' : colorScreenCard,
                        backgroundColor: isDarkMode ? '#121212' : '#ffffff',
                        borderStyle: 'solid',
                        borderRadius: '0.75rem',
                        height: '100%',
                        boxShadow: 'none'
                    }
                }
            },
            MuiAvatar: {
                styleOverrides: {
                    root: {
                        '& .MuiAvatar-img': {
                            borderRadius: 8,
                        }
                    }
                }
            },
            MuiDialog: {
                styleOverrides: {
                    root: {
                        '& .MuiDialog-paper': {
                            padding: rawTheme.spacing(3),
                            [rawTheme.breakpoints.down('sm')]: {
                                padding: rawTheme.spacing(2),
                                margin: rawTheme.spacing(0),
                            }
                        }
                    },
                }
            },
            MuiDialogContent: {
                styleOverrides: {
                    root: {
                        [rawTheme.breakpoints.down('sm')]: {
                            padding: rawTheme.spacing(1),
                        }
                    }
                }
            },
            MuiDialogTitle: {
                styleOverrides: {
                    root: {
                        padding: rawTheme.spacing(1, 0),
                    }
                }
            },
            MuiLink: {
                styleOverrides: {
                    root: {
                        ':hover': {
                            cursor: 'pointer'
                        },
                        textDecoration: "none",
                        fontSize: '0.875rem'
                    }
                }
            },
            MuiTab: {
                styleOverrides: {
                    root: {
                        textTransform: 'capitalize',
                    }
                }
            },
            MuiListItem: {
                styleOverrides: {
                    root: {
                        borderBottom: '1px solid',
                        borderColor: isDarkMode ? 'rgba(255,255,255,0.12)' : colorScreenCard
                    }
                }
            },
            MuiChip: {
                styleOverrides: {
                    root: {
                        fontSize: '0.75rem',
                    }
                },
                variants: [
                    {
                        props: { variant: 'customOutlined' },
                        style: {
                            borderRadius: 5,
                            padding: '8px 2px 8px 2px',
                        },
                    },
                ]
            },
            MuiTableHead: {
                styleOverrides: {
                    root: {
                        backgroundColor: isDarkMode ? 'unset' : 'lightgray',
                        borderBottom: isDarkMode ? '1px solid rgba(255,255,255,0.12)' : undefined,
                        '& th:first-of-type': {
                            borderRadius: '12px 0 0 12px'
                        },
                        '& th:last-child': {
                            borderRadius: '0 12px 12px 0'
                        }
                    }
                }
            },
            MuiTableCell: {
                styleOverrides: {
                    root: {
                        padding: '10px 16px 10px 16px'
                    }
                }
            },
            MuiMenu: {
                // styleOverrides: {
                //     root: {
                //         '& .MuiPopover-paper': {
                //             width: '35%',
                //             padding: rawTheme.spacing(2, 3),
                //             borderRadius: rawTheme.spacing(2),
                //             [rawTheme.breakpoints.down('md')]: {
                //                 width: '80%',
                //             },
                //             [rawTheme.breakpoints.down('sm')]: {
                //                 padding: rawTheme.spacing(1, 2),
                //                 width: '100%',
                //             },
                //         }
                //     }
                // },
                variants: [
                    {
                        props: { variant: 'tableRowMenu' },
                        style: {
                            '& .MuiPopover-paper': {
                                width: '10%',
                                padding: rawTheme.spacing(0, 0),
                                borderRadius: rawTheme.spacing(1),
                                boxShadow: '0px 10px 15px #0000000D'

                            },
                            '& .MuiMenuItem-root': {
                                fontSize: '0.875rem',
                                fontFamily: commonFont.regular,
                                color: '#001A41',
                            },
                        },
                    },
                ]
            },
            MuiCircularProgress: {
                styleOverrides: {
                    root: {
                        width: "24px!important",
                        height: '24px!important',
                        color: isDarkMode ? '#ffffff' : 'black'
                    }
                }
            },
            MuiFormHelperText: {
                styleOverrides: {
                    root: {
                        fontSize: rawTheme.typography.subtitle2.fontSize,
                        marginLeft: 0,
                        marginRight: 0
                    }
                }
            },
            MuiPaper: {
                styleOverrides: {
                    root: {
                        '& .MuiMenu-list': {
                            maxHeight: '30vh'
                        }
                    }
                }
            },
            MuiAutocomplete: {
                styleOverrides: {
                    root: {
                        '& .MuiAutocomplete-input': {
                            padding: `${rawTheme.spacing(0.5)}!important`,
                            width: '100%'
                        }
                    }
                }
            }
        },
        palette: {
            mode: isDarkMode ? 'dark' : 'light',
            primary: {
                light: colorScreenButton + "80",
                main: colorScreenButton,
                dark: colorScreenButton,
                contrastText: '#ffffff'
            },
            secondary: {
                light: landingPageButton + "80",
                main: landingPageButton,
                dark: landingPageButton,
                contrastText: landingPageText,
                background: landingPageBg
            },
            success: {
                light: '#E3FCEF',
                main: isDarkMode ? '#059b69' : '#006644',
                contrastText: '#ffffff',
            },
            error: {
                light: '#FFEBE6',
                main: '#BF2600',
                contrastText: '#ffffff',
            },
            warning: {
                light: '#fff8e6',
                main: '#c79c1a',
                contrastText: '#ffffff',
            },
            info: {
                light: isDarkMode ? '#016D88' : '#0095B917',
                main: isDarkMode ? '#ffffff' : '#016D88',
                contrastText: '#ffffff',
            },
            custom1: {
                light: isDarkMode ? '#e80e4563' : '#E80E4514',
                main: '#DB052C',
                contrastText: '#ffffff',
            },
            custom2: {
                light: isDarkMode ? '#03186b' : '#005BA714',
                main: isDarkMode ? '#ffffff' : '#00104D',
                contrastText: '#ffffff',
            },
            custom3: {
                light: '#8D339514',
                main: '#8D3395',
                contrastText: '#ffffff',
            },
            background: rawTheme.palette.augmentColor({
                color: {
                    main: isDarkMode ? '#121212' : colorScreenCard,
                    light: '#F5F5F7',
                    icon: isDarkMode ? '#ffffff' : colorScreenCard,
                    card: isDarkMode ? 'linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05))' : '#ffffff'
                },
                name: 'background',
            }),
            border: rawTheme.palette.augmentColor({
                color: {
                    main: isDarkMode ? 'rgba(255, 255, 255, 0.12)' : colorScreenCard,
                    dark: '#E3E8EE'
                },
                name: 'border',
            }),
            textCustom: rawTheme.palette.augmentColor({
                color: {
                    main: isDarkMode ? 'rgba(255, 255, 255, 0.7)' : '#212121',
                    light: isDarkMode ? 'rgba(255, 255, 255, 0.7)' : '#86868B'
                },
                name: 'textCustom',
            }),
            textMenuCustom: rawTheme.palette.augmentColor({
                color: {
                    main: isDarkMode ? '#ffffff' : '#001A41',
                },
                name: 'textMenuCustom',
            }),
            shortcut: rawTheme.palette.augmentColor({
                color: {
                    main: isDarkMode ? '#ffffff' : '#1D1D1F',
                },
                name: 'shortcut',
            }),
            icon: rawTheme.palette.augmentColor({
                color: {
                    main: isDarkMode ? '#ffffff' : '#1D1D1F',
                },
                name: 'icon',
            }),
            light: rawTheme.palette.augmentColor({
                color: {
                    main: '#ffffff',
                    contrastText: colorScreenButton,
                    dark: "#ffffff"
                },
                name: 'light',
            }),
        },
        typography: {
            allVariants: {
                color: isDarkMode ? "#ffffff" : '#212121',
                fontFamily: commonFont.regular
            },
            h1: {
                fontFamily: commonFont.boldCondensed,
                fontSize: '2.5rem',
                [rawTheme.breakpoints.down('sm')]: {
                    fontSize: '2rem',
                }
            },
            h2: {
                fontFamily: commonFont.bold,
                fontSize: '2rem',
                [rawTheme.breakpoints.down('sm')]: {
                    fontSize: '2rem',
                }
            },
            h3: {
                fontFamily: commonFont.medium,
                fontSize: '1.75rem',
                [rawTheme.breakpoints.down('sm')]: {
                    fontSize: '1.25rem',
                }
            },
            h4: {
                fontFamily: commonFont.medium,
                fontSize: '1.5rem',
                [rawTheme.breakpoints.down('sm')]: {
                    fontSize: '1.25rem',
                }
            },
            h5: {
                fontFamily: commonFont.medium,
                fontSize: '1.25rem',
                [rawTheme.breakpoints.down('sm')]: {
                    fontSize: '1.125rem',
                }
            },
            h6: {
                fontFamily: commonFont.medium,
                fontSize: '1.125rem',
                [rawTheme.breakpoints.down('sm')]: {
                    fontSize: '1rem',
                }
            },
            caption: {
                fontFamily: commonFont.bold,
                fontSize: '1.125rem',
                [rawTheme.breakpoints.down('sm')]: {
                    fontSize: '1rem',
                }
            },
            body1: {
                fontFamily: commonFont.bold,
                fontSize: '1rem',
                [rawTheme.breakpoints.down('sm')]: {
                    fontSize: '0.875rem',
                }
            },
            body2: {
                fontFamily: commonFont.regular,
                fontSize: '1rem',
                [rawTheme.breakpoints.down('sm')]: {
                    fontSize: '0.875rem',
                }
            },
            subtitle1: {
                fontFamily: commonFont.medium,
                fontSize: '0.875rem',
                [rawTheme.breakpoints.down('sm')]: {
                    fontSize: '0.75rem',
                }
            },
            subtitle2: {
                fontFamily: commonFont.regular,
                fontSize: '0.875rem',
                [rawTheme.breakpoints.down('sm')]: {
                    fontSize: '0.75rem',
                }
            },
        },

    });
    console.log("AAAA theme: ", theme)
    return theme
};

function getColor(colours, key) {
    let value = null;
    if (colours) {
        let dataFilter = colours.filter(e => {
            return e.type == key;
        })
        if (dataFilter && dataFilter.length > 0) {
            value = dataFilter[0].value;
        }
    }
    return value;
}

export default theme;